<script lang="ts">
    import type { Availability } from '@shared/types/types.ts';
    import Delivery from '@tile/components/delivery/Delivery.svelte';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';

    interface Props {
        availability: Availability | undefined;
        ottoUp: boolean | undefined;
    }

    let { availability, ottoUp }: Props = $props();

    const onex = injectWiring().onex;
    const deliveryDateExperimentActive = $derived(onex.isExperimentGroup('DELIVERY_DATE', 'E3917B'));
    const deliveryText = $derived.by(() => {
        const detailDate = availability?.detailDate;
        return deliveryDateExperimentActive && detailDate?.trim() ? detailDate : availability?.detail;
    });
</script>

<Delivery availabilityText={deliveryText} {ottoUp} />
